import { observer } from 'mobx-react-lite'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { CapturedInformationCardContainer } from '@/features/jobs/details/components/CapturedInformationCard/CapturedInformationCardContainer'
import { ResponsesCardContainer } from '@/features/jobs/details/components/ResponsesCard/ResponsesCardContainer'
import { AmendmentsCardContainer } from '@/features/jobs/details/components/AmendmentsCard/AmendmentsCardContainer'
import { MobileDetails } from '@/features/jobs/details/components/MobileJob'

export interface MobileDetailsTabContainerProps {
  vm: JobDetailsViewModel
}

export const MobileDetailsTabContainer = observer(
  function MobileDetailsTabContainer({ vm }: MobileDetailsTabContainerProps) {
    if (vm.showDraftView) {
      return (
        <MobileDetails>
          {vm.detailsVm.canViewCapturedInfoCard && (
            <CapturedInformationCardContainer vm={vm} />
          )}
          {vm.actionsVm.canViewAmendments && (
            <AmendmentsCardContainer vm={vm} />
          )}
        </MobileDetails>
      )
    }

    return (
      <MobileDetails>
        {vm.detailsVm.canViewCapturedInfoCard ? (
          <CapturedInformationCardContainer vm={vm} />
        ) : (
          <ResponsesCardContainer vm={vm} />
        )}
      </MobileDetails>
    )
  },
)
